import React from 'react'
import logo from '../../Icons/softwaredevelopment.jpeg';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Padding from '../Padding';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class Vision extends React.Component {
    render() {
      return (

      <div id='Vision' style={{backgroundColor: '#0d0d12'}}>

        <NavBar/>
        <Padding/>
        <Padding/>
        <div className="container-text" style={{padding:"30px"}}>
            <h2>Machine Vision</h2>
            <div> 



<div className="generic-column" style={{ width: '100%' }}>
    <h3>Vision Systems & Quality Inspection</h3>
    <p>
        Design and integration of advanced optical systems, providing automated 
        inspection, measurement, and data capture solutions across a diverse range 
        of industrial and laboratory environments.
    </p>

    <p>
        We have extensive expertise in deploying and programming the following vision technologies:
    </p>

    <div className="usp-list">
        <div className="usp-item">
            <strong>Cognex</strong>
            <span>
                As a global leader in industrial machine vision, these systems are utilised for 
                reliable 2D and 3D inspection, barcode reading, and optical character recognition (OCR) 
                within Pharmaceutical, Automotive, and Logistics sectors.
            </span>
        </div>

        <div className="usp-item">
            <strong>Keyence</strong>
            <span>
                Known for precision and ease of integration, these sensors are ideal for 
                measurement and surface defect detection where sub-millimetre accuracy is 
                required, regardless of the process cycle time.
            </span>
        </div>

        <div className="usp-item">
            <strong>Teledyne DALSA</strong>
            <span>
                Specialising in high-performance digital imaging, we utilise these systems for 
                demanding applications such as high-resolution line scan inspection and 
                advanced multi-camera processing for complex manufacturing environments.
            </span>
        </div>

        <div className="usp-item">
            <strong>Matrox Imaging</strong>
            <span>
                Trusted for high-end PC-based vision, we utilise Matrox hardware and software 
                libraries for complex image analysis, high-speed frame grabbing, and 
                long-term industrial stability in mission-critical applications.
            </span>
        </div>

        <div className="usp-item">
            <strong>OpenCV</strong>
            <span>
                For bespoke software solutions requiring maximum flexibility, we utilise this 
                open-source library to develop custom image processing algorithms and 
                feature detection within C# and Python environments.
            </span>
        </div>

        <div className="usp-item">
            <strong>Deep Learning</strong>
            <span>
                We implement AI-driven vision for complex anomaly detection using TensorFlow 
                and PyTorch. This allows for sophisticated classification and inspection 
                where products have high natural variance or unpredictable defects.
            </span>
        </div>
    </div>
</div>





           </div>
        </div>

        <Padding/>
        <Padding/>

        <Sales/>
        <SEO/>
      </div>
  
      )
    }
  }

export default Vision;

